import { render, staticRenderFns } from "./BottomComponent.vue?vue&type=template&id=b3f83e30&"
import script from "./BottomComponent.vue?vue&type=script&lang=js&"
export * from "./BottomComponent.vue?vue&type=script&lang=js&"
import style0 from "./BottomComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports